import { Modal } from "antd";
import { pipViewDate2 } from "../../../utils/pip";

const FreelancerJobDetailsModal = ({
  isOpen,
  onClose,
  job,
  onApply,
  similarJobs = [],
  onSelectJob,
  onSave,
  isSaving,
  onScheduleAction,
}) => {
  if (!job) return null;

  const salaryRange =
    job?.min_salary || job?.max_salary
    ? `${job?.salary_currency || ""}${job?.min_salary || ""}${
        job?.max_salary ? ` - ${job?.salary_currency || ""}${job?.max_salary}` : ""
      }`
    : "";
  const isAlreadyApplied =
    String(job?.status || "").toLowerCase() === "applied" ||
    String(job?.application_status || "").toLowerCase() === "applied" ||
    job?.is_applied ||
    Boolean(job?.applied_id);
  const isSaved =
    typeof job?.is_saved === "boolean"
      ? job.is_saved
      : typeof job?.is_saved === "number"
      ? job.is_saved === 1
      : typeof job?.is_saved === "string"
      ? job.is_saved.toLowerCase() === "true"
      : false;
  const scheduledDateTime = job?.scheduled_time
    ? `${pipViewDate2(job?.scheduled_time)} ${new Date(
        job?.scheduled_time
      ).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })}`
    : "";

  return (
    <Modal
      visible={isOpen}
      onCancel={onClose}
      centered
      footer={null}
      className="ct_job_details_modal"
      width={1100}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body px-4 pb-5">
            {job?.scheduled_time && (
              <div className="ct_outline_bg ct_border_radius_10 p-3 mb-3 d-flex align-items-center justify-content-between gap-3 flex-wrap">
                <p className="mb-0 ct_fs_14 ct_darkblue_text">
                  Interview scheduled at{" "}
                  <strong className="ct_fw_600">{scheduledDateTime}</strong>
                </p>
                {["accepted", "rejected"].includes(
                  String(job?.schedule_status || "").toLowerCase()
                ) ? (
                  <span
                    className={`ct_fw_600 text-capitalize ${
                      String(job?.schedule_status || "").toLowerCase() ===
                      "accepted"
                        ? "ct_green_text"
                        : "ct_red_text"
                    }`}
                  >
                    {String(job?.schedule_status || "")}
                  </span>
                ) : (
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="ct_yellow_btn ct_sky_blue_btn px-4"
                      type="button"
                      onClick={() => {
                        if (onScheduleAction) onScheduleAction(job, "accept");
                      }}
                    >
                      Accept
                    </button>
                    <button
                      className="ct_yellow_btn ct_orange_btn px-4"
                      type="button"
                      onClick={() => {
                        if (onScheduleAction) onScheduleAction(job, "reject");
                      }}
                    >
                      Reject
                    </button>
                  </div>
                )}
              </div>
            )}
            <div className="d-flex align-items-start justify-content-between gap-3 mb-4">
              <div>
                <h3 className="ct_fs_24 ct_darkblue_text mb-1">
                  {job?.job_title || "Job Details"}
                </h3>
                <div className="d-flex align-items-center gap-3 flex-wrap">
                  <span className="ct_fw_600 ct_darkblue_text">
                    {job?.company_name || "#N/A"}
                  </span>
                  {job?.location && (
                    <span className="ct_fs_14 ct_grey_text">
                      {job?.location}
                    </span>
                  )}
                </div>
              </div>
              <div className="d-flex align-items-center gap-2">
                {!isAlreadyApplied && (
                  <button
                    className="ct_yellow_btn ct_h_44 px-4"
                    type="button"
                    onClick={() => {
                      if (onApply) onApply(job);
                    }}
                  >
                    Apply Now
                  </button>
                )}
                <button
                  className="ct_outline_btn ct_h_44 px-3"
                  type="button"
                  onClick={() => {
                    if (onSave) onSave(job);
                  }}
                  disabled={isSaving}
                >
                  <i
                    className={
                      isSaved
                        ? "fa-solid fa-bookmark"
                        : "fa-regular fa-bookmark"
                    }
                  ></i>
                </button>
                <button className="ct_outline_btn ct_h_44 px-3">
                  <i className="fa-solid fa-share-nodes"></i>
                </button>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-8">
                <div className="d-flex align-items-center gap-3 flex-wrap mb-3">
                  {job?.candidate_availability && (
                    <span className="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_14 ct_darkblue_text" style={{ backgroundColor: "hsl(0deg 0% 93% / 50%)" }}>
                      {job?.candidate_availability}
                    </span>
                  )}
                  {job?.candidate_location && (
                    <span className="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_14 ct_darkblue_text" style={{ backgroundColor: "hsl(0deg 0% 93% / 50%)" }}>
                      {job?.candidate_location}
                    </span>
                  )}
                  {job?.years_of_experience && (
                    <span className="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_14 ct_darkblue_text" style={{ backgroundColor: "hsl(0deg 0% 93% / 50%)" }}>
                      {job?.years_of_experience} Years
                    </span>
                  )}
                </div>

                <ul className="list-unstyled ct_fs_14">
                  {salaryRange && (
                    <li className="mb-2">
                      <strong className="ct_fw_600">Salary:</strong>{" "}
                      <span>{salaryRange}</span>
                    </li>
                  )}
                  {job?.industry && (
                    <li className="mb-2">
                      <strong className="ct_fw_600">Industry:</strong>{" "}
                      <span>{job?.industry}</span>
                    </li>
                  )}
                  {job?.category && (
                    <li className="mb-2">
                      <strong className="ct_fw_600">Category:</strong>{" "}
                      <span>{job?.category}</span>
                    </li>
                  )}
                  {job?.posted_date && (
                    <li className="mb-2">
                      <strong className="ct_fw_600">Posted:</strong>{" "}
                      <span>{pipViewDate2(job?.posted_date)}</span>
                    </li>
                  )}
                </ul>

                {job?.about_role && (
                  <div className="mt-4">
                    <h5 className="ct_fs_18 ct_darkblue_text mb-2">
                      About this role
                    </h5>
                    <p className="ct_grey_text mb-0">{job?.about_role}</p>
                  </div>
                )}

                {job?.job_description && (
                  <div className="mt-4">
                    <h5 className="ct_fs_18 ct_darkblue_text mb-2">
                      Job Description
                    </h5>
                    <p className="ct_grey_text mb-0">{job?.job_description}</p>
                  </div>
                )}

                {job?.qualification && (
                  <div className="mt-4">
                    <h5 className="ct_fs_18 ct_darkblue_text mb-2">
                      Qualification
                    </h5>
                    <p className="ct_grey_text mb-0">{job?.qualification}</p>
                  </div>
                )}

                {job?.responsibility && (
                  <div className="mt-4">
                    <h5 className="ct_fs_18 ct_darkblue_text mb-2">
                      Responsibilities
                    </h5>
                    <p className="ct_grey_text mb-0">{job?.responsibility}</p>
                  </div>
                )}
              </div>

              {similarJobs.length > 0 && (
                <div className="col-lg-4">
                  <div className="ct_outline_bg ct_border_radius_10 ct_p_20 ct_box_shadow_card_1">
                    <h5 className="ct_fs_18 ct_darkblue_text mb-3">
                      Similar Jobs
                    </h5>
                    {similarJobs.map((item) => (
                      <div
                        key={item?.id}
                        className="ct_outline_bg ct_border_radius_10 ct_p_15 mb-3 ct_cursor_pointer"
                        onClick={() => {
                          if (onSelectJob) onSelectJob(item);
                        }}
                      >
                        <div className="d-flex align-items-center justify-content-between gap-2">
                          <div>
                            <p className="mb-0 ct_fw_600">
                              {item?.job_title || "#N/A"}
                            </p>
                            <p className="mb-0 ct_fs_12 ct_grey_text">
                              {item?.company_name || "#N/A"}
                            </p>
                          </div>
                          <i className="fa-regular fa-bookmark"></i>
                        </div>
                        <div className="d-flex align-items-center gap-2 mt-2 flex-wrap">
                          {item?.candidate_availability && (
                            <span className="ct_job_tag">
                              {item?.candidate_availability}
                            </span>
                          )}
                          {item?.candidate_location && (
                            <span className="ct_job_tag">
                              {item?.candidate_location}
                            </span>
                          )}
                          {item?.years_of_experience && (
                            <span className="ct_job_tag">
                              {item?.years_of_experience} Years
                            </span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default FreelancerJobDetailsModal;
